export default "__VITE_ASSET__YKmcp2AM__"